import { render, staticRenderFns } from "./RefClaimList.vue?vue&type=template&id=001cecf5&"
import script from "./RefClaimList.vue?vue&type=script&lang=js&"
export * from "./RefClaimList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports